angular.module('onboarding.common',
	[
		'ngCookies'
	]);
